
// images
import Aline from "../../assets/Pannel Members/Aline .webp";
import Marko from "../../assets/Pannel Members/marko.webp";
import Bonginkosi from "../../assets/Pannel Members/Bon.webp";
import William from "../../assets/Pannel Members/willimas.webp";

export const panel_members_about = [
  {
    id: "Paul",
    image: Aline,
    name: "Aline Theodoro Toci",
    from: " Brazil",
    about: " Federal University of Latin American Integration ",
    // link: "/executive-panel-members/velimir",
  },
  {
    id: "Koji Nomura ",
    image: Marko,
    name: "Marko Vinceković" ,
    from: " Croatia",
    about: " University of Zagreb Faculty of Agriculture ",
    // link: "/executive-panel-members/Raenu",
  },
  {
    id: "Rd",
    image:Bonginkosi,
    name: " Bonginkosi E. Mthembu",
    from: "South Africa",
    about: "Mangosuthu University of Technology",
    // link: "/executive-panel-members/Rd",
  },
  {
    id: "Paulo",
    image: William,
    name: "William Meng",
    from: "Australia",
    about: "Victorian Academy of Teaching",
    // link: "/executive-panel-members/Paulo",
  },
  // Second row
  // {
  //   id: "yew",
  //   image: yew, // replace with the correct image variable for Eric
  //   name: "Yew Kee Wong Eric",
  //   from: "Hong Kong",
  //   about: "HKU-SPACE, Southern Institute of Technology (New Zealand)",
  //   link: "/executive-panel-members/yew-kee-wong-eric",
  // },

  // {
  //   id: "rami-ahmad-el-nabulsi",
  //   image: RamiImage, // Replace with the actual imported image variable or URL
  //   name: "Rami Ahmad El-Nabulsi",
  //   from: "France",
  //   about: "Professor",
  //   link: "/executive-panel-members/rami-ahmad-el-nabulsi",
  // },
  // {
  //   id: "abdullah-aydin",
  //   image: AbdullahImage, // Replace with the actual imported image variable or URL
  //   name: "Abdullah Aydın",
  //   from: "Turkey",
  //   about: "Professor ",
  //   link: "/executive-panel-members/abdullah-aydin",
  // },

  // {
  //   id: "vladimir-g-chigrinov",
  //   image: vladimirGChigrinov, // replace with actual image import
  //   name: "Vladimir G. Chigrinov",
  //   from: "Hong Kong",
  //   about:
  //     "Professor at Hong Kong University of Science and Technology since 1999, renowned for Flat Panel Technology and liquid crystals research. Author of 6 books, 31 reviews, 333 journal papers, 718 conference presentations, and 121 patents. Editor-in-Chief of the Liquid Crystal section in Crystals journal.",
  //   link: "/executive-panel-members/vladimir-g-chigrinov",
  // },
  // {
  //   id: "mohammad-arif-kamal",
  //   image: mohammadArifKamal, // replace with actual image import
  //   name: "Dr. Mohammad Arif Kamal",
  //   from: "India",
  //   about:
  //     "Associate Professor at Aligarh Muslim University with 20+ years of experience in Architecture, Building Technology, and Interior Design. Holds B.Arch. (Hons), M.Arch., and Ph.D. in Energy Responsiveness in Traditional Residential Buildings. Author of 5 books, editor of 4 volumes, and ~120 papers. Focused on Sustainable Architecture and Climate Responsive Design.",
  //   link: "/executive-panel-members/mohammad-arif-kamal",
  // },
  // {
  //   id: "alireza-heidari",
  //   image: alirezaHeidari, // replace with actual image import
  //   name: "Prof. Dr. Alireza Heidari",
  //   from: "USA",
  //   about:
  //     "Full Distinguished Professor at California South University, Irvine, holding Enrico Fermi Distinguished Chair in Molecular Spectroscopy. Expert in Biophysical Chemistry, Quantum Chemistry, Nanochemistry. Leads Cancer Research Institute and BioSpectroscopy Core Research Lab. Author of 20+ books and active in 900+ international conferences.",
  //   link: "/executive-panel-members/alireza-heidari",
  // },
  // {
  //   id: "jiasheng-zhu",
  //   image: jiashengZhu, // replace with actual image import
  //   name: "Dr. Jiasheng Zhu",
  //   from: "China",
  //   about:
  //     "Assistant Researcher at Wuhu Hart Robot Technology Research Institute. Specializes in robotic technologies for shipbuilding, digital twin systems, and spraying process dynamics. Project manager for COSCO Group and Wuhu Digang Shipyard projects. Holds 13 patents, 11 publications, and contributed to national/provincial standards on magnetic wall-climbing robots.",
  //   link: "/executive-panel-members/jiasheng-zhu",
  // },
  // {
  //   id: "raman-singh",
  //   image: ramanSingh, // replace with actual image import
  //   name: "Professor Raman Singh",
  //   from: "Australia",
  //   about:
  //     "Research focuses on Nano-/microstructure, environment-assisted degradation of metals/composites, stress corrosion cracking, and graphene applications. Guest Professor at ETH Zurich, 265+ publications, 15 books/book chapters, 60+ keynotes, supervised 53 PhD students. Editor-in-chief of key journals and recipient of multiple competitive grants.",
  //   link: "/executive-panel-members/raman-singh",
  // },
  // {
  //   id: "uqbah-iqbal",
  //   image: uqbahIqbal, // replace with actual image import
  //   name: "Dr. Uqbah Iqbal",
  //   from: "Malaysia",
  //   about:
  //     "Founder and Managing Director of Pitas Agriculture. Historian with multiple awards including Best Researcher and Lifetime Achievement. Authored 71 books/ebooks, 414 journal articles, organized 821 conferences, and earned 9,500+ certificates. Youngest PhD holder in History from Universiti Kebangsaan Malaysia.",
  //   link: "/executive-panel-members/uqbah-iqbal",
  // },
];

export const panel_members = panel_members_about;

// export const velimir_data = {
//   id: "velimir",
//   image: velimir,
//   name: "Velimir V Vesselinov",
//   from: "USA",
//   about:
//     " Dr. Velimir V Vesselinov is the CTO and co-founder of EnvTrace. He spent over 20 years as a scientist at Los Alamos National Laboratory and was a tenured professor at the University of Mining and Geology, Sofia, Bulgaria. He holds an M.Sc. in geological engineering and a Ph.D. in engineering hydrology. Dr. Vesselinov has led numerous multi-institutional research projects on geologic carbon storage, climate change, and more. He has developed novel methods and software in data analytics, statistical analyses, and machine learning, earning 2 R&D100 awards and a machine-learning patent. He has published over 100 papers with an h-index of 30.",
//   banner:
//     "https://t4.ftcdn.net/jpg/07/68/48/19/360_F_768481918_VmWYi1nQVP0grVGjBBUJ7qNomt0onwR0.webp",
//   link: "/executive-panel-members/velimir",
// };

// export const raenu_kolandaisamy_data = {
//   id: "raenu-kolandaisamy",
//   image: Raenu,
//   name: "Raenu Kolandaisamy",
//   from: "Malaysia",
//   about:
//     "Dr. Raenu Kolandaisamy is an Assistant Professor and Director of the Institute of Computer Science & Digital Innovation (ICSDI) at UCSI University in Kuala Lumpur, Malaysia. He earned his Ph.D. from the Faculty of Computer Science & Information Technology at the University of Malaya in 2020. His research interests encompass cybersecurity, VANET (Vehicular Ad-Hoc Networks), IoT (Internet of Things), blockchain, and information technology. Dr. Kolandaisamy has contributed to various publications, including studies on security, e-wallets and e-waste perception.",
//   banner:
//     "https://media.istockphoto.com/id/657672748/vector/flag-of-malaysia.jpg?s=612x612&w=0&k=20&c=UoU4BgTTdhrdedryBeyhQZOadnPrhRDLIaWm5TcnD00=",
//   link: "/executive-panel-members/Raenu",
// };

// export const rdsg_campilho_data = {
//   id: "rdsg-campilho",
//   image: Rd,
//   name: "R.D.S.G. Campilho",
//   from: "Portugal",
//   about:
//     "Raul Duarte Salgueiral Gomes Campilho is a Permanent Auxiliar Professor at ISEP, Porto, Portugal. He holds a PhD in Mechanical Engineering from FEUP, where he also earned his Master’s and Habilitation degrees. With over two decades of teaching experience, Raul has supervised numerous Ph.D., M.Sc., and B.Sc. theses. He has authored 42 books and 170 book chapters and has published 380 papers in renowned international journals. As Editor-in-Chief of Academia Materials Science Journal, he has contributed significantly to the field. Additionally, Raul has presented at various conferences and actively participated in funded research projects. For more information, please visit his professional webpage",
//   banner:
//     "https://media.istockphoto.com/id/483663073/vector/flag-of-portugal.jpg?s=612x612&w=0&k=20&c=JOAj0sAYKSn9B35gyCyrAEZs0APEhwVENHlCfHnMHhw=",
//   link: "/executive-panel-members/Rd",
// };

// export const paulo_cesar_de_morais_data = {
//   id: "paulo-cesar-de-morais",
//   image: Panueo,
//   name: "Paulo Cesar De Morais",
//   from: "Brazil",
//   about:
//     "Professor De Morais, PhD, was full Professor of Physics at the University of Brasilia (UnB) – Brazil up to 2013. UnB’s Emeritus Professor (2014); Visiting Professor at the Huazhong University of Science and Technology (HUST) – China (2012-2015); Distinguished Professor at the Anhui University (AHU) – China (2016-2019); Full Professor at the Catholic University of Brasília (CUB) – Brazil (since 2018); CNPq-1A Research Fellow since 2010; 2007 Master Research Prize from UnB. Held two-years (1987-1988) post-doc position with Bell Communications Research, New Jersey – USA. Doctoral degree in Solid State Physics (1986) from the Federal University of Minas Gerais (UFMG) – Brazil. With more than 12,500 citations, He has published more than 500 papers (Web of Science) and more than 16 patents.",
//   banner:
//     "https://wallpapers.com/images/hd/brazil-flag-in-silk-ipri8roaxci23qo3.webp",
//   link: "/executive-panel-members/Paulo",
// };

// export const yew_kee_wong_eric_data = {
//   id: "yew-kee-wong-eric",
//   image: yew,
//   name: "Yew Kee Wong Eric",
//   from: "Hong Kong",
//   about:
//     "Prof. WONG (Eric), with a PhD in AI from Nottingham Trent University, is a highly accomplished academic and researcher. He has held significant roles at institutions such as Hong Kong Chu Hai College, HKU-SPACE, and Southern Institute of Technology (New Zealand). His expertise spans AI, Quantum Computing, Web3 Technology, and Big Data Analytics. Over his 30-year career, he has secured over USD $10 million in research funding, published 180+ peer-reviewed papers in top-tier journals, and supervised 80+ PhD/Master students. He is an esteemed Fellow and member of 12 global professional organizations, editor for 21 international journals, and has served on over 3,000 technical committees. Additionally, he has been associated with 15 universities as a professor or research fellow.",
//   banner:
//     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQiJnOPcOy91cGdY7SKxK042wvIFsKF4i3dA&s",
//   link: "/executive-panel-members/yew-kee-wong-eric",
// };

// export const rami_ahmad_el_nabulsi_data = {
//   id: "rami-ahmad-el-nabulsi",
//   image: RamiImage,
//   name: "Rami Ahmad El-Nabulsi",
//   from: "France",
//   about:
//     "Rami Ahmad El-Nabulsi holds a PhD in Particle Physics, Mathematical Physics and Modeling from Provence University (currently Aix-Marseille University), France and a diploma of advanced studies in Plasma Physics and Radiation Astrophysics from the same institution. He worked with different worldwide research departments in UK, South Korea, China, Greece, Thailand, India, Europe, etc. He is the author of more than 385 peer-reviewed papers in peer-refereed reputed journals and a reviewer for more than 200 scientific journals. He has been selected as the World’s Top 2% Scientists 2021 and 2022 (by Stanford University). His research ranges from applied mathematics to theoretical physics.",
//   banner:
//     "https://wallpapers.com/images/hd/france-flag-waving-on-wind-zxbe7au3q3p1d2yy.webp",
//   link: "/executive-panel-members/rami-ahmad-el-nabulsi",
// };


// export const epms_details_map = {
//   // ⭐ Newly added ones
//   velimir: velimir_data,
//   Raenu: raenu_kolandaisamy_data,
//   Rd: rdsg_campilho_data,
//   Paulo: paulo_cesar_de_morais_data,

// };
